<template>
    <div class="contents">
        <div class="container-fluid">
            <FollowUpNavigation />
            
            <!-- Alert jika tidak ada add-on follow up -->
            <div v-if="!hasFollowUpAddon" class="row mb-4">
                <div class="col-12">
                    <div class="alert alert-warning d-flex align-items-center" role="alert">
                        <i class="fas fa-exclamation-triangle me-3" style="font-size: 24px;"></i>
                        <div class="flex-grow-1">
                            <h5 class="alert-heading mb-2"><strong>Add-On Follow Up Belum Aktif</strong></h5>
                            <p class="mb-2">Anda belum memiliki add-on Follow Up Otomatis. Silakan upgrade paket Anda untuk mengaktifkan fitur ini.</p>
                            <router-link to="/billing" class="btn btn-primary btn-sm">
                                <i class="fas fa-shopping-cart me-2"></i>
                                Upgrade Paket
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="hasFollowUpAddon" class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Daftar Follow Up
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <router-link to="/follow-up/add" class="btn px-15 btn-primary text-white" style="display: inline-flex; margin: 5px">
                                <i class="fas fa-plus fs-16"></i>
                                Buat Follow Up Baru
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="hasFollowUpAddon" class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <FollowUpTable ref="followUpTable" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FollowUpTable from "@/components/tables/FollowUp.vue";
import FollowUpNavigation from "@/components/followup/Navigation.vue";

export default {
    components: {
        FollowUpTable,
        FollowUpNavigation
    },
    computed: {
        hasFollowUpAddon() {
            return this.$store.state.auth.package?.follow_up == 1;
        }
    },
    mounted() {
        if (this.hasFollowUpAddon) {
            this.$refs.followUpTable.loadItems();
        }
    }
};
</script>


